import React, { useState } from "react";
import { Button, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const CopyUrlButton = () => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleCopy = () => {
    let url = window.location.href; // Get full URL
    url = url.replace(/\/permissions/, ""); // Remove "/permissions"
    navigator.clipboard.writeText(url); // Copy to clipboard
    setTooltipOpen(true);
    setTimeout(() => setTooltipOpen(false), 2000);
  };

  const { t } = useTranslation();
  return (
    <Tooltip
      title={t("buttons.clipBoardMessage")}
      open={tooltipOpen}
      arrow
      placement="bottom"
    >
      <Button
        variant="outlined"
        color="primary"
        onClick={handleCopy}
        startIcon={<ContentCopyIcon />}
        sx={{ height: "100%", width: "100%", fontWeight: "bold" }}
      >
        {t("buttons.copyUrl")}
      </Button>
    </Tooltip>
  );
};

export default CopyUrlButton;
